
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h2a093d517d94edd4': html`<em>reseñas de</em> 1 estrella `,
'ha02853bd9d715922': html`<em>reseñas de </em>${undefined} estrellas y más `,
'hb94ceff2d6bea555': html`<em>reseñas de </em> ${undefined} estrella `,
's02bf5241683ddb90': `Bueno (660-699)`,
's05a238937d0d0e2a': `No se encontraron coincidencias para tu selección.`,
's089297421a0eedd6': `reseñas`,
's08b05407b5565ca4': `or`,
's118d4d5705dc3af9': `Monto financiado`,
's11f0d4805e155fe1': `¿Dónde vives?`,
's141b773d7fd6fa29': `Usa el título de tu auto para tener más oportunidades de un préstamo mayor`,
's22713f64c729416e': `y más`,
's2cc7cd11d9b856cd': `Categorías`,
's2e2dd419ed27c52b': `Paga `,
's2eb13f7956dbcbc8': `No, no tengo auto`,
's2f74875ee0868d8f': `Sucursales`,
's307795b666ff5a25': `Necesita mejorar (debajo 580)`,
's32cf9f4f44c1a333': `con préstamos personales en`,
's33f18e24c0f02137': `Sábado:`,
's35d0183d3e7956bb': `Buscar por dirección, código postal, ciudad o estado`,
's3606b9d856cdbafe': `Ordenar por`,
's39211f8cdcd58d9b': `Indicaciones`,
's39fc74b0ff29278d': `Precisar reseñas`,
's3d5e13a41be7cbfa': `Aceptable (580-659)`,
's40664bffa760c01c': `Mostrando`,
's43c0315623d4fd77': `Puntaje desconocido / No puntaje`,
's5d929ff1619ac0c9': `Buscar`,
's5e005d880b6345f0': `Cargo por pago devuelto`,
's5f18ad2335efdc47': `Muy bueno (700-749)`,
's61b294f82a34dddc': `Numero de pagos`,
's6b5c5b615bc905d4': `Puntaje de crédito estimado`,
's6d9cfdb6312e952b': `Aplica para un préstamo`,
's7584ded3d749c75e': `Carga más`,
's79f2525594bda923': `Sí, todavía estoy haciendo pagos`,
's7a57fd915566c247': `cada dos semanas`,
's7e1cc4ee33997748': ` Préstamos garantizados`,
's7f845078d7a5c0b5': `de`,
's8023cca78fa76ede': `De menor a mayor`,
's808c054e41aa8a0d': `Más recientes`,
's86c910f0aa9f8e2f': `sucursales`,
's8c245429c6dec8e2': `Hacer un pago`,
's8e117fe546d1d983': `Cargo por pago retrasado`,
's8f90406e9a94abe6': `sucursal`,
's93ba0262c24d5721': `millas`,
's9544962a7c1befa8': `Excepcional (750-850)`,
's97987596c2779ce1': `Reseñas más altas`,
'sa0fc61989d2eaf48': `Plazo del préstamo`,
'sa62b15e722a205fc': `Aplicar una vez y obtener dos grandes opciones`,
'sa890a5e7d007e83c': `Obtén el app`,
'saac21e40a54fff35': `una vez al mes`,
'sae94af9791e8199a': `Préstamos personales`,
'sb0ffa04c9225566f': `Lunes-Viernes:`,
'sb22524aa70ff6204': `De mayor a menor`,
'sb3890cd1737117f3': `Ver reseñas de`,
'sb59d68ed12d46377': `Cargando`,
'sca81470958a97fc4': `Filtrar reseñas`,
'sca8b41d21a6a3c89': `Sí, soy dueño y ya no pago nada por mi auto`,
'sca92f1ee12551cc2': `Esta herramienta ofrece ejemplos de precios y de plazos de préstamos para préstamos personales estándares. Los plazos reales varían según la información de la solicitud, el perfil de crédito y la ley correspondiente del estado. Los plazos mostrados pueden cambiar sin previo aviso.`,
'sce24479e1166ee8d': `Préstamos personales`,
'sce40d9ceecde8a29': `No pudimos encontrar sucursales ahí. Prueba buscar otra sucursal o modifica un poco el nombre de la ciudad.`,
'se09f67825582d4e5': `Reseñas más bajas`,
'se16c3a252343cfe1': `Domingo:`,
'se337e3fccd7d7098': `Costo administrativo`,
'se36599241f046acf': `¿Eres dueño de tu auto?`,
'se459dbc1adc59941': ` Préstamos garantizados`,
'sedb5d32f53cbe086': `Comienza tu solicitud de préstamo`,
'sf20ee7c80221676a': `Puedes aplicar en línea para un préstamo personal en `,
'sf36fd35510558d4d': `Monto del préstamo`,
'sf47c4b39340c356a': `Máx.`,
'sf82ac8b4c087ab2e': `No, yo arriendo un auto`,
'sf993bb199fefbe04': `Todas`,
'sfe5857d2790cdd68': `Todas sucursales`,
'sb4afbf86edbb068c': `Unable to load loan amounts`,
'sb2a7fdd1a678ef5a': `Unable to calculate loan amounts`,
'sbf1c196aac84a616': `Questions related to`,
'saa350e9122cd4e6c': `You can apply online in `,
's7aa74a4b2491d6b3': `Apply now`,
    };
  